// src/components/layout/ClientLayout.js
import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function ClientLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-gray-50 via-white to-primary-50/30">
      <Header />
      <main className="flex-1">
        <div className="mx-auto max-w-7xl px-4 py-8">
          <div className="animate-fadeIn">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ClientLayout;
